import React, { useCallback,useContext } from 'react'

import cx from 'classnames'

import RightSidebar from 'components/RightSidebar'
import { Card,OpenedSidebar, SidebarOpenContext } from 'context/sidebarOpenContext'

import DealActivityCard, { DealActivityCardHeader } from './DealActivityCard'
import DealRoomCardsContainer, { DealRoomCardHeader } from './DealRoomCard'
import DetailsCard, { DetailsCardHeader } from './DetailsCard'
import InsightsCard, { Header as InsightsCardHeader } from './InsightsCard'

import styles from './styles.module.css'

interface ExpandableSectionProps {
  expanded: boolean
  renderSectionHeader: ({
    expandable,
    expanded
  }: {
    expandable: boolean
    expanded: boolean
  }) => React.ReactElement
  children: React.ReactElement
  onClick: () => void
}

const ExpandableSection: React.FC<ExpandableSectionProps> = ({
  expanded,
  renderSectionHeader,
  children,
  onClick
}) => {
  return (
    <div className={styles.expandableSection}>
      <div className={styles.expandableSectionHeader} onClick={onClick}>
        {renderSectionHeader({ expandable: true, expanded })}
      </div>
      <div className={cx(styles.expandableContent, { [styles.expanded]: expanded })}>
        {expanded && children}
      </div>
      <div className={styles.bottomSectionBorder}></div>
    </div>
  )
}

const DealSidebar: React.FC = () => {
  const { setOpenedRightSidebar, sidebarDeal, expandedCards, setExpandedCards } = useContext(
    SidebarOpenContext
  )

  const toggleExpandedCard = useCallback(
    (card: Card) => {
      if (expandedCards.includes(card)) {
        setExpandedCards(expandedCards.filter(c => c !== card))
      } else {
        setExpandedCards([...expandedCards, card])
      }
    },
    [expandedCards, setExpandedCards]
  )
  const title = sidebarDeal?.name || 'Deal details'
  const subTitle = sidebarDeal?.accountName || ''

  return (
    <RightSidebar
      header={title}
      subHeader={subTitle}
      onCollapse={() => {
        setOpenedRightSidebar(OpenedSidebar.NONE)
      }}
      className={styles.dealRightSidebar}>
      <div className={styles.detailsSidebarContentContainer}>
        <ExpandableSection
          renderSectionHeader={props => <InsightsCardHeader {...props} />}
          expanded={expandedCards.includes(Card.DEAL_INSIGHTS)}
          onClick={() => toggleExpandedCard(Card.DEAL_INSIGHTS)}>
          <InsightsCard deal={sidebarDeal} />
        </ExpandableSection>
        <ExpandableSection
          renderSectionHeader={props => <DealActivityCardHeader {...props} />}
          expanded={expandedCards.includes(Card.DEAL_ACTIVITY)}
          onClick={() => toggleExpandedCard(Card.DEAL_ACTIVITY)}>
          <DealActivityCard deal={sidebarDeal} />
        </ExpandableSection>
        <ExpandableSection
          renderSectionHeader={props => <DealRoomCardHeader {...props} />}
          expanded={expandedCards.includes(Card.DEAL_ROOMS)}
          onClick={() => toggleExpandedCard(Card.DEAL_ROOMS)}>
          <DealRoomCardsContainer deal={sidebarDeal} />
        </ExpandableSection>
        <ExpandableSection
          renderSectionHeader={props => <DetailsCardHeader {...props} />}
          expanded={expandedCards.includes(Card.DEAL_DETAILS)}
          onClick={() => toggleExpandedCard(Card.DEAL_DETAILS)}>
          <DetailsCard deal={sidebarDeal} />
        </ExpandableSection>
      </div>
    </RightSidebar>
  )
}

export default DealSidebar
